module.exports = __webpack_public_path__ + "img/a3.5ea4dae2.png";